import $$ from 'cmn-utils'

const baseUrl = "/api/sys/uicomponent/";
export default {
    list: (params) => {
        return $$.get(baseUrl + 'list', params)
    },
    one: (params) => {
        return $$.get(baseUrl + 'one', params)
    }

}